export default __webpack_public_path__ + "static/media/protectionofset.b4586842.png";